// Contact form modal
export function contactForm() {
  const body = document.body;
  const formClose = document.querySelector('.js-form-close');

  // Modal form open
  [...document.querySelectorAll('[href="#contact"]')]?.forEach( formOpen => {

    if (formOpen) {
      formOpen.addEventListener('click', function(e) {
        e.preventDefault();
        body.classList.add('modal-open');
      })
    }

  });

  // Modal form Close
  if (formClose) {
    formClose.addEventListener('click', function(e) {
      e.preventDefault();
      body.classList.remove('modal-open');
    })
  }

}